import { MutationHookOptions, useMutation } from '@apollo/client';

import { ADD_PARENT_CONSULTATION } from './mutations';

export const useAddParentToConsultation = (options?: MutationHookOptions) => useMutation(ADD_PARENT_CONSULTATION, options);
